"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uiBox = require("ui-box");

var _theme = require("../../theme");

var _layers = require("../../layers");

var _typography = require("../../typography");

var _icon = require("../../icon");

var InlineAlert =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(InlineAlert, _PureComponent);

  function InlineAlert() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, InlineAlert);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(InlineAlert)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getIconForIntent", function (intent) {
      var theme = _this.props.theme;
      return _react.default.createElement(_icon.Icon, (0, _extends2.default)({
        size: 14,
        marginTop: 2
      }, theme.getIconForIntent(intent)));
    });
    return _this;
  }

  (0, _createClass2.default)(InlineAlert, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          children = _this$props.children,
          intent = _this$props.intent,
          hasIcon = _this$props.hasIcon,
          size = _this$props.size,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["theme", "children", "intent", "hasIcon", "size"]);
      return _react.default.createElement(_layers.Pane, (0, _extends2.default)({
        alignItems: "center",
        display: "flex"
      }, props), hasIcon && _react.default.createElement(_layers.Pane, {
        display: "inline",
        marginRight: 8
      }, this.getIconForIntent(intent)), _react.default.createElement(_typography.Text, {
        size: size,
        fontWeight: 500
      }, children));
    }
  }]);
  return InlineAlert;
}(_react.PureComponent);

InlineAlert.displayName = "InlineAlert";
(0, _defineProperty2.default)(InlineAlert, "propTypes", (0, _objectSpread2.default)({}, _uiBox.spacing.propTypes, _uiBox.position.propTypes, _uiBox.layout.propTypes, _uiBox.dimensions.propTypes, {
  /**
   * The content of the alert.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),

  /**
   * The intent of the alert. This should always be set explicitly.
   */
  intent: _propTypes.default.oneOf(['none', 'success', 'warning', 'danger']).isRequired,

  /**
   * When true, show a icon on the left matching the type.
   * There is no point not showing this.
   */
  hasIcon: _propTypes.default.bool,

  /**
   * The size of the Text.
   */
  size: _propTypes.default.number,

  /**
   * Theme provided by ThemeProvider.
   */
  theme: _propTypes.default.object.isRequired
}));
(0, _defineProperty2.default)(InlineAlert, "defaultProps", {
  intent: 'none',
  hasIcon: true,
  size: 400
});

var _default = (0, _theme.withTheme)(InlineAlert);

exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/alert/src/InlineAlert.js
// module id = 137
// module chunks = 0